// extracted by mini-css-extract-plugin
export default {"hero-section":"Hero_hero-section__UsHc5","hero-section__title":"Hero_hero-section__title__Eo+Zx","hero-section__metadata":"Hero_hero-section__metadata__tPFY0"};